<template>
    <div class="main-container">

        <router-view></router-view>
        <!-- Navbar section -->
        <HeaderAppLanding />

    <div class="contact-form-section section-space--ptb_120" id="contact">
			<div data-tf-widget="MJYucV7J" data-tf-iframe-props="title=Contact" style="width:100%;height:400px;"></div>
			<script type="application/javascript" src="//embed.typeform.com/next/embed.js" />
		</div>

    </div>
</template>

<script>
    import HeaderAppLanding from '../components/HeaderAppLanding'

    export default {
        name: 'app',
        components: {
            HeaderAppLanding,
        },

        metaInfo: {
            title: 'Dyjest - Home Patients',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        }
    }
</script>